<template>
	<component :is="component" />
</template>

<script>
import { mapActions } from 'vuex';
import { enterTriggerMode } from '@/store/modules/selectedWorkflow/actions';
import AddOnTriggerEditor from './AddOnTriggerEditor.vue';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { isOfTypeFeature, isOfTypeTool } from '@/store/modules/selectedWorkflow/getters';
import ToolTriggerEditor from './ToolTriggerEditor.vue';
export default {
	name: 'TriggerEditor',
	computed: {
		...mapGettersShorthand({ isOfTypeTool, isOfTypeFeature }),
		component() {
			if (this.isOfTypeFeature) {
				return AddOnTriggerEditor;
			} else if (this.isOfTypeTool) {
				return ToolTriggerEditor;
			} else {
				return null;
			}
		},
	},
	methods: {
		...mapActions([enterTriggerMode.fullPath]),
	},
	async mounted() {
		await this[enterTriggerMode.fullPath]();
	},
};
</script>
<style lang="scss" scoped></style>
